"use client"

import ErrorHandler from "~/components/ui/ErrorHandler"

export default ErrorHandler
